import { Component, Input, OnInit } from "@angular/core";
import { Contracts } from "src/app/models/contracts";
import { History } from "../../models/history";
import { PortalService } from "../../services/portal-service.service";

@Component({
  standalone: false,
  selector: "app-activity-tab",
  templateUrl: "./activity-tab.component.html",
  styleUrls: ["./activity-tab.component.scss"],
})
export class ActivityTabComponent implements OnInit {
  activities = [];
  @Input() contract: Contracts;
  showActivations = true;
  showReturns = true;
  showTokens = true;
  queryString = "";
  loading = true;
  sortKey: "date" | "action" | "product" | "hostname" | "count" | "comment" = "date";
  sortDirection: "asc" | "desc" = "desc";
  constructor(private ps: PortalService) {}

  ngOnInit() {
    this.getContractHistory();
  }

  getContractHistory() {
    this.loading = true;
    return this.ps.GetContractHistory(this.contract.id).subscribe(
      (data: History[]) => {
        this.activities = data.sort((a, b) => new Date(b.timestamp).getTime() / 1000 - new Date(a.timestamp).getTime() / 1000);
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }

  sortBy(key: "date" | "action" | "product" | "hostname" | "count" | "comment"): void {
    if (this.sortKey === key) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      return;
    }

    this.sortKey = key;
    this.sortDirection = key === "date" ? "desc" : "asc";
  }

  getSortIcon(key: "date" | "action" | "product" | "hostname" | "count" | "comment"): string {
    if (this.sortKey !== key) return "unfold_more";
    return this.sortDirection === "asc" ? "arrow_upward" : "arrow_downward";
  }

  get displayedActivities(): History[] {
    const query = (this.queryString || "").trim().toLowerCase();
    const filtered = (this.activities || []).filter((activity) => {
      const actionMatch =
        (this.showActivations && activity.action === "ACTIVATION") ||
        (this.showReturns && activity.action === "RETURN") ||
        (this.showTokens && activity.action === "TOKEN");

      if (!actionMatch) return false;
      if (!query) return true;
      return JSON.stringify(activity).toLowerCase().includes(query);
    });

    return [...filtered].sort((a, b) => this.compareActivity(a, b));
  }

  private compareActivity(a: History, b: History): number {
    const direction = this.sortDirection === "asc" ? 1 : -1;
    switch (this.sortKey) {
      case "action":
        return direction * String(a.action || "").localeCompare(String(b.action || ""));
      case "product":
        return direction * String(a.product || "").localeCompare(String(b.product || ""));
      case "hostname":
        return direction * String(a.hostname || "").localeCompare(String(b.hostname || ""));
      case "count":
        return direction * ((a.count || 0) - (b.count || 0));
      case "comment":
        return direction * String(a.comment || "").localeCompare(String(b.comment || ""));
      case "date":
      default:
        return direction * (new Date(a.timestamp || 0).getTime() - new Date(b.timestamp || 0).getTime());
    }
  }
}
